const getQuery = (obj: Record<string, unknown>) =>
  Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');

export default getQuery;
